import React from 'react';
import PropTypes from 'prop-types';
import { Typography, TextField } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import useStyles from './useStyles';

const Search = props => {
  const { values, onChange } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <Typography variant="h1">{t('components.RealEstateAgentLoanOfficers.Search.header')}</Typography>
      <div className={classes.searchFields}>
        <TextField
          variant="outlined"
          id="name"
          name="name"
          label={t('components.RealEstateAgentLoanOfficers.Search.name')}
          onChange={onChange}
          value={values.name}
          className={classes.field}
          InputLabelProps={{
            shrink: false,
          }}
        />
        <TextField
          variant="outlined"
          id="company"
          name="company"
          label={t('components.RealEstateAgentLoanOfficers.Search.company')}
          onChange={onChange}
          value={values.company}
          className={classes.field}
          InputLabelProps={{
            shrink: false,
          }}
        />
        <TextField
          variant="outlined"
          id="location"
          name="location"
          label={t('components.RealEstateAgentLoanOfficers.Search.location')}
          onChange={onChange}
          value={values.location}
          className={classes.field}
          InputLabelProps={{
            shrink: false,
          }}
        />
      </div>
    </div>
  );
};

Search.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape().isRequired,
};
export default Search;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/Search/Search.js